export const prettyBytes = (bytes: number) => {
  if (bytes <= 0) return '0 Bytes';

  if (bytes === 1) return '1 Byte';

  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const k = 1024;
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${units[i]}`;
};

export const copyToClipboard = async (value: string) => {
  if ('clipboard' in navigator) {
    return await navigator.clipboard.writeText(value);
  }
};
